export default {
      id: "icon-twitter-usage",
      viewBox: "0 0 67 67",
      url: "../icon/" + "icons.svg#icon-twitter-usage",
      toString: function () {
        return this.url;
      }
    }